module.exports = __webpack_public_path__ + "static/media/development_04@3x.f643fad8.png";